export default ({
  S3: {
    "Bucket": "bms.viatick.com",
    "Key": "api-tracking.json",
    "IdentityPoolId": "ap-northeast-1:0e941249-c56c-462f-af51-06958c4ae1f3"
  }
});
